import { useMemo } from 'react';

const SINGLE_SOLD_ITEM = 1;
const DOUBLE_SOLD_ITEMS = 2;

type ImageConfig = {
    className: string;
    imageUrl?: string;
    zIndex: number;
};

type SearchPageZeroResultsImagesProps = {
    imageUrls: string[];
};

export const SearchPageZeroResultsImages = ({ imageUrls }: SearchPageZeroResultsImagesProps) => {
    const totalSoldItems = imageUrls.length;

    const imageConfigs: ImageConfig[] = useMemo(() => {
        if (totalSoldItems === SINGLE_SOLD_ITEM) {
            return [
                {
                    className:
                        'relative flex h-64 w-64 smMax:h-[173px] smMax:w-[173px] items-center justify-center overflow-hidden rounded-lg border-4 border-border-inverse bg-background-primary shadow-02',
                    imageUrl: imageUrls[0],
                    zIndex: 10,
                },
            ];
        }

        if (totalSoldItems === DOUBLE_SOLD_ITEMS) {
            return [
                {
                    className:
                        'relative z-10 mt-6 flex h-64 w-64 smMax:h-[173px] smMax:w-[173px] -rotate-12 items-center justify-center overflow-hidden rounded-lg border-4 border-border-inverse bg-background-primary shadow-02',
                    imageUrl: imageUrls[0],
                    zIndex: 10,
                },
                {
                    className:
                        'relative z-10 -ml-8 smMax:-ml-10 mt-6 flex h-64 w-64 smMax:h-[173px] smMax:w-[173px] rotate-12 items-center justify-center overflow-hidden rounded-lg border-4 border-border-inverse bg-background-primary shadow-02',
                    imageUrl: imageUrls[1],
                    zIndex: 10,
                },
            ];
        }

        return [
            {
                className:
                    'relative z-10 mt-8 flex h-48 w-48 smMax:h-32 smMax:w-32 -rotate-12 items-center justify-center overflow-hidden rounded-lg border-4 border-border-inverse bg-background-primary shadow-02',
                imageUrl: imageUrls[1],
                zIndex: 10,
            },
            {
                className:
                    'relative z-[15] -ml-24 smMax:-ml-16 flex h-64 w-64 smMax:h-[173px] smMax:w-[173px] items-center justify-center overflow-hidden rounded-lg border-4 border-border-inverse bg-background-primary shadow-02',
                imageUrl: imageUrls[0],
                zIndex: 20,
            },
            {
                className:
                    'relative z-10 -ml-24 smMax:-ml-16  mt-8 flex h-48 w-48 smMax:h-32 smMax:w-32 rotate-12 items-center justify-center overflow-hidden rounded-lg border-4 border-border-inverse bg-background-primary shadow-02',
                imageUrl: imageUrls[2],
                zIndex: 10,
            },
        ];
    }, [imageUrls, totalSoldItems]);

    const containerClassName = useMemo(() => {
        if (totalSoldItems === SINGLE_SOLD_ITEM) {
            return 'relative flex gap-xs';
        }
        if (totalSoldItems === DOUBLE_SOLD_ITEMS) {
            return 'relative flex gap-xs px-6 pb-6';
        }
        return 'relative flex gap-xs pl-4 pr-4';
    }, [totalSoldItems]);

    if (totalSoldItems === 0) {
        return null;
    }

    return (
        <div className={`${containerClassName}`}>
            {imageConfigs.map((config) => (
                <div
                    className={config.className}
                    key={config.imageUrl}
                >
                    {config.imageUrl && (
                        <img
                            alt="Sold item"
                            className="h-full w-full object-cover"
                            src={config.imageUrl}
                        />
                    )}
                </div>
            ))}
        </div>
    );
};
